export default __webpack_public_path__ + "images/onboarding/ela-cart-ccd7fb8e795ba06b35a4a0d445cbe381.svg";